module.exports = __webpack_public_path__ + "img/foot.c1af50c.svg";